function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Modal as ModalSemantic, Grid, Button, Segment, Label, Input } from 'semantic-ui-react';
import ModalActions from "./ModalActions";
import ModalContent from "./ModalContent";
import ModalDescription from "./ModalDescription";
import ModalHeader from "./ModalHeader";
import { getRest } from "../../utils";

/**
 * Modal.
 *
 * @class Modal
 * @extends {React.PureComponent}
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Modal = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Modal, _React$PureComponent);
  /**
     * Constructor.
     *
     * @param  {...any} args
     */
  function Modal() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    /**
       * Check if rest contains header to apply className.
       *
       * @memberof Modal
       */
    _this.checkIfHeader = function (rest) {
      if (!_.isNil(rest) && _.isArray(rest)) {
        return _.map(rest, function (r) {
          return _this.checkIfHeader(r);
        });
      }
      if (!_.isNil(rest) && !_.isNil(rest.header) && /*#__PURE__*/React.isValidElement(rest.header)) {
        if (rest.header.type === ModalSemantic.Header || rest.header.type === Modal.Header) {
          _this.setState({
            hasHeader: true
          });
        }
      }
      if (!_.isNil(rest) && !_.isNil(rest.children) && /*#__PURE__*/React.isValidElement(rest.children)) {
        if (rest.children.type === ModalSemantic.Header || rest.children.type === Modal.Header) {
          _this.setState({
            hasHeader: true
          });
        }
      }
      if (!_.isNil(rest) && /*#__PURE__*/React.isValidElement(rest)) {
        if (rest.type === ModalSemantic.Header || rest.type === Modal.Header) {
          _this.setState({
            hasHeader: true
          });
        }
      }
      if (!_.isNil(rest) && !_.isNil(rest.children) && _.isArray(rest.children)) {
        return _.map(rest.children, function (r) {
          return _this.checkIfHeader(r);
        });
      }
      return null;
    };
    /**
       * Handle change input confirmation.
       *
       * @memberof Modal
       */
    _this.handleChangeConfirmation = function (_ref) {
      var target = _ref.target;
      return _this.setState({
        valueConfirmation: target.value
      });
    };
    /**
       * Handle cancel for actions of confirmation.
       *
       * @memberof Modal
       */
    _this.handleCancel = function () {
      var onCancel = _this.props.onCancel;
      if (onCancel) {
        _this.setState({
          valueConfirmation: '',
          errorConfirmation: false
        });
        onCancel();
      }
    };
    /**
       * Handle save for actions of confirmation.
       *
       * @memberof Modal
       */
    _this.handleSave = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var onSave, valueConfirmation;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            onSave = _this.props.onSave;
            valueConfirmation = _this.state.valueConfirmation;
            if (_.isEqual(valueConfirmation, 'OUI')) {
              _context.next = 6;
              break;
            }
            _this.setState({
              errorConfirmation: true
            });
            _context.next = 11;
            break;
          case 6:
            _this.setState({
              loadingConfirmation: true
            });
            if (!onSave) {
              _context.next = 10;
              break;
            }
            _context.next = 10;
            return onSave();
          case 10:
            _this.setState({
              loadingConfirmation: false,
              errorConfirmation: false,
              valueConfirmation: ''
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    /**
       * Handle close.
       *
       * @memberof Modal
       */
    _this.handleClose = function () {
      var onClose = _this.props.onClose;
      if (onClose) {
        _this.setState({
          valueConfirmation: '',
          errorConfirmation: false
        });
        onClose();
      }
    };
    /**
       * Render content confirmation.
       *
       * @memberof Modal
       */
    _this.renderContentConfirmation = function () {
      var _this$state = _this.state,
        valueConfirmation = _this$state.valueConfirmation,
        errorConfirmation = _this$state.errorConfirmation;
      return /*#__PURE__*/_jsx(Grid.Row, {
        style: {
          padding: 0
        },
        children: /*#__PURE__*/_jsx(Grid.Column, {
          children: /*#__PURE__*/_jsxs(Segment.Inline, {
            children: ["Veuillez saisir \"OUI\" en toutes lettres pour confirmer le traitement \xA0\xA0\xA0", /*#__PURE__*/_jsx(Input, Object.assign({
              style: {
                width: 80
              },
              value: valueConfirmation,
              onChange: _this.handleChangeConfirmation
            }, errorConfirmation ? {
              error: true
            } : null))]
          })
        })
      });
    };
    /**
       * Render content.
       *
       * @memberof Modal
       */
    _this.renderContent = function (rest) {
      var confirmation = _this.props.confirmation;
      var _ref3 = rest || {},
        children = _ref3.children;
      return /*#__PURE__*/_jsxs(React.Fragment, Object.assign({}, !_.isNil(rest) && !_.isNil(rest.key) ? {
        key: rest.key
      } : null, {
        children: [_this.renderError(), /*#__PURE__*/_jsx(ModalContent, Object.assign({}, _.omit(rest, 'as'), {
          children: /*#__PURE__*/_jsxs(Grid, {
            children: [/*#__PURE__*/_jsx(Grid.Row, {
              children: /*#__PURE__*/_jsx(Grid.Column, {
                children: /*#__PURE__*/React.isValidElement(children) ? _this.renderContentRecursif(children) : children
              })
            }), confirmation === 'avecOui' && _this.renderContentConfirmation()]
          })
        }))]
      }));
    };
    /**
       * Render actions.
       *
       * @memberof Modal
       */
    _this.renderActions = function (rest) {
      var _this$props = _this.props,
        confirmation = _this$props.confirmation,
        suppression = _this$props.suppression;
      var loadingConfirmation = _this.state.loadingConfirmation;
      if (confirmation) {
        if (suppression) {
          return /*#__PURE__*/_jsxs(ModalSemantic.Actions, {
            children: [/*#__PURE__*/_jsx(Button, Object.assign({
              onClick: _this.handleCancel,
              size: "tiny",
              basic: true
            }, loadingConfirmation && {
              disabled: true
            }, {
              children: "Annuler"
            })), /*#__PURE__*/_jsx(Button, Object.assign({
              color: "red",
              onClick: _this.handleSave
            }, loadingConfirmation && {
              disabled: true,
              loading: true
            }, {
              children: "Supprimer"
            }))]
          });
        }
        return /*#__PURE__*/_jsxs(ModalSemantic.Actions, {
          children: [/*#__PURE__*/_jsx(Button, Object.assign({
            onClick: _this.handleCancel,
            size: "tiny",
            basic: true
          }, loadingConfirmation && {
            disabled: true
          }, {
            children: "Annuler"
          })), /*#__PURE__*/_jsx(Button, Object.assign({
            color: "green",
            onClick: _this.handleSave
          }, loadingConfirmation && {
            disabled: true,
            loading: true
          }, {
            children: "Valider"
          }))]
        });
      }
      return !_.isNil(rest) && /*#__PURE__*/_jsx(ModalSemantic.Actions, Object.assign({}, _.omit(rest, 'onActionClick')));
    };
    /**
       * Render header.
       *
       * @memberof Modal
       */
    // eslint-disable-next-line class-methods-use-this
    _this.renderHeader = function (rest) {
      return !_.isNil(rest) && /*#__PURE__*/_jsx(ModalSemantic.Header, Object.assign({}, rest, {
        as: Segment,
        inverted: true,
        style: {
          paddingTop: '0.8rem',
          paddingBottom: '0.8rem',
          borderRadius: 0,
          color: 'white'
        }
      }));
    };
    /**
       * Render error.
       *
       * @memberof Modal
       */
    _this.renderError = function () {
      var errorConfirmation = _this.state.errorConfirmation;
      return errorConfirmation && /*#__PURE__*/_jsx(Segment, {
        as: Modal.Description,
        basic: true,
        style: {
          marginTop: 0,
          marginBottom: 0,
          paddingBottom: 0
        },
        children: /*#__PURE__*/_jsx(Label, {
          color: "red",
          ribbon: true,
          children: "Confirmation incorrecte"
        })
      });
    };
    /**
       * Méthode récursive pour rendre le contenu de la modal
       * On cherche dans les children du rest
       *
       * @memberof Modal
       */
    _this.renderContentRecursif = function (rest) {
      if (_.isArray(rest)) {
        return [].concat(_.map(rest, _this.renderContentRecursif));
      }
      if ( /*#__PURE__*/React.isValidElement(rest)) {
        if (rest.type === ModalSemantic.Header || rest.type === Modal.Header) {
          return _this.renderHeader(Object.assign({}, rest.props, !_.isNil(rest.key) ? {
            key: rest.key
          } : null));
        }
        if (rest.type === ModalSemantic.Content || rest.props.as === ModalSemantic.Content || rest.type === Modal.Content || rest.props.as === Modal.Content) {
          return _this.renderContent(Object.assign({}, rest.props, !_.isNil(rest.key) ? {
            key: rest.key
          } : null));
        }
        if (rest.type === ModalSemantic.Actions || rest.type === Modal.Actions) {
          return _this.renderActions(Object.assign({}, rest.props, !_.isNil(rest.key) ? {
            key: rest.key
          } : null));
        }
        if (!_.isNil(rest.props.children) && _.isArray(rest.props.children)) {
          return /*#__PURE__*/React.createElement.apply(React, [rest.type, Object.assign({}, rest.props, !_.isNil(rest.key) ? {
            key: rest.key
          } : null)].concat(_.map(rest.props.children, function (r) {
            return _this.renderContentRecursif(r);
          })));
        }
        //
        if (!_.isNil(rest.props.children) && /*#__PURE__*/React.isValidElement(rest.props.children)) {
          return /*#__PURE__*/React.createElement(rest.type, Object.assign({}, rest.props, !_.isNil(rest.key) ? {
            key: rest.key
          } : null), _this.renderContentRecursif(rest.props.children));
        }
        return /*#__PURE__*/React.createElement(rest.type, Object.assign({}, rest.props, !_.isNil(rest.key) ? {
          key: rest.key
        } : null));
      }
      return null;
    };
    _this.state = {
      /** Value of input's confirmation. */
      valueConfirmation: '',
      /** If error in confirmation. */
      errorConfirmation: false,
      /** Waiting for confirmation answer. */
      loadingConfirmation: false,
      /** If modal has header (to apply classname for cross position). */
      hasHeader: false
    };
    return _this;
  }
  var _proto = Modal.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var rest = getRest(Modal, this.props);
    this.checkIfHeader(rest);
  };
  /**
     * Render the component.
     *
     * @returns
     * @memberof Modal
     *
     */
  _proto.render = function render() {
    var rest = getRest(Modal, this.props);
    var _ref4 = this.props || {},
      contentProps = _ref4.content,
      headerProps = _ref4.header,
      actionsProps = _ref4.actions,
      confirmation = _ref4.confirmation,
      parametrage = _ref4.parametrage;
    var hasHeader = this.state.hasHeader;
    var content;
    var header;
    var actions;
    var defaultProps = false;
    if (!_.isNil(rest.children)) {
      if (_.isArray(rest.children)) {
        _.map(rest.children, function (restChild) {
          if (!_.isNil(restChild.type)) {
            switch (restChild.type) {
              case ModalSemantic.Content:
              case ModalContent:
                content = Object.assign({}, restChild.props, !_.isNil(restChild.key) ? {
                  key: restChild.key
                } : null);
                break;
              case ModalSemantic.Header:
              case ModalHeader:
                header = Object.assign({}, restChild.props, !_.isNil(restChild.key) ? {
                  key: restChild.key
                } : null);
                break;
              case ModalSemantic.Actions:
              case ModalActions:
                actions = Object.assign({}, restChild.props, !_.isNil(restChild.key) ? {
                  key: restChild.key
                } : null);
                break;
              default:
                defaultProps = true;
                content = restChild;
            }
          } else {
            content = restChild;
            defaultProps = true;
          }
        });
      } else if (!_.isNil(rest.children.type)) {
        switch (rest.children.type) {
          case ModalSemantic.Content:
          case ModalContent:
            content = Object.assign({}, rest.children.props, !_.isNil(rest.children.key) ? {
              key: rest.children.key
            } : null);
            break;
          case ModalSemantic.Header:
          case ModalHeader:
            header = Object.assign({}, rest.children.props, !_.isNil(rest.children.key) ? {
              key: rest.children.key
            } : null);
            break;
          case ModalSemantic.Actions:
          case ModalActions:
            actions = Object.assign({}, rest.children.props, !_.isNil(rest.children.key) ? {
              key: rest.children.key
            } : null);
            break;
          default:
            defaultProps = true;
            content = rest.children;
        }
      }
    }
    if (_.isNil(content) && !_.isNil(contentProps) && !defaultProps) {
      content = contentProps.props;
    }
    if (_.isNil(header) && !_.isNil(headerProps) && !defaultProps) {
      header = headerProps.props;
    }
    if (_.isNil(actions) && !_.isNil(actionsProps) && !defaultProps) {
      actions = actionsProps.props;
    }
    return /*#__PURE__*/_jsxs(ModalSemantic, Object.assign({}, _.omit(rest, ['children', 'content', 'header']), {
      className: (hasHeader ? 'hasHeader' : '') + " " + (parametrage ? 'parametrage' : ''),
      onClose: this.handleClose,
      children: [!_.isNil(header) ? this.renderHeader(header) : null, defaultProps ? this.renderContentRecursif(content) : this.renderContent(content), !_.isNil(actions) || !_.isNil(confirmation) ? this.renderActions(actions) : null]
    }));
  };
  return Modal;
}(React.PureComponent);

/**
 * Proptypes.
 */
Modal.Header = ModalHeader;
Modal.Content = ModalContent;
Modal.Actions = ModalActions;
Modal.Description = ModalDescription;
Modal.handledProps = ["confirmation", "onCancel", "onClose", "onSave", "parametrage", "suppression"];
Modal.propTypes = {
  /** Si c'est une modal de confirmation. */
  confirmation: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['avecOui'])]),
  /** Si c 'est une modal de suppression. */
  suppression: PropTypes.bool,
  /** Modal paramétrage ? */
  parametrage: PropTypes.bool,
  /** Fonction de validation pour une modal de confirmation. */
  onSave: PropTypes.func,
  /** Fonction d'annulation pour une modal de confirmation. */
  onCancel: PropTypes.func,
  /** Fonction de fermeture pour la modal. */
  onClose: PropTypes.func
};
export default Modal;